import { Moment } from 'moment-timezone';

export const shiftSelectedDateByWeeks = (
    selectedDate: Moment,
    weeks: number,
    minDate?: Moment,
    maxDate?: Moment
): Moment => {
    const date = selectedDate.clone().add(weeks, 'weeks');

    if (minDate && date.isBefore(minDate, 'day')) {
        return minDate.clone();
    }

    if (maxDate && date.isAfter(maxDate, 'day')) {
        return maxDate.clone();
    }

    return date;
};
